import list_module_default from "./list.module.js";
import { List } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/list/List.tsx
const ListItem = ({ icon, styles = {}, ...rest }) => {
	return /* @__PURE__ */ jsx(List.Item, {
		styles: {
			...styles,
			itemIcon: { alignSelf: icon ? "start" : void 0 }
		},
		icon,
		...rest
	});
};
const List$1 = ({ children, compact = false, dataTestId, "data-testid": testId = dataTestId ?? "list", icon, listStyleType, type = "unordered" }) => {
	return /* @__PURE__ */ jsx(List, {
		"data-testid": testId,
		classNames: { itemWrapper: list_module_default.itemWrapper },
		styles: {
			itemIcon: { alignSelf: icon ? "start" : void 0 },
			itemLabel: { maxWidth: "100%" },
			itemWrapper: {
				maxWidth: "100%",
				paddingRight: "var(--mantine-spacing-sm)"
			}
		},
		center: !!icon,
		icon,
		listStyleType,
		spacing: compact ? "xs" : "sm",
		type,
		children
	});
};

//#endregion
export { List$1 as List, ListItem };